import { GridClasses_GridTemplateAreas_$ctor_Z207A3CFB, GridClasses_GridAutoFlow_$ctor_Z207A3CFB, GridClasses_GridAuto_$ctor_Z207A3CFB, GridClasses_GridTemplate_$ctor_Z207A3CFB, GridClasses_GridGap_$ctor_Z207A3CFB, GridClasses_GridTwoGap_$ctor_Z207A3CFB, GridClasses_GridRow_$ctor_Z207A3CFB, GridClasses_GridColumn_$ctor_Z207A3CFB, GridClasses_GridPosition_$ctor_Z207A3CFB } from "../Types/Grid.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const GridArea = GridClasses_GridPosition_$ctor_Z207A3CFB(new Property_CssProperty(125));

export const GridColumn = GridClasses_GridPosition_$ctor_Z207A3CFB(new Property_CssProperty(131));

export const GridColumnStart = GridClasses_GridColumn_$ctor_Z207A3CFB(new Property_CssProperty(130));

export const GridColumnEnd = GridClasses_GridColumn_$ctor_Z207A3CFB(new Property_CssProperty(129));

export const GridRow = GridClasses_GridRow_$ctor_Z207A3CFB(new Property_CssProperty(137));

export const GridRowStart = GridClasses_GridColumn_$ctor_Z207A3CFB(new Property_CssProperty(136));

export const GridRowEnd = GridClasses_GridColumn_$ctor_Z207A3CFB(new Property_CssProperty(133));

export const GridGap = GridClasses_GridTwoGap_$ctor_Z207A3CFB(new Property_CssProperty(132));

export const GridRowGap = GridClasses_GridGap_$ctor_Z207A3CFB(new Property_CssProperty(134));

export const GridColumnGap = GridClasses_GridGap_$ctor_Z207A3CFB(new Property_CssProperty(135));

export const GridTemplateRows = GridClasses_GridTemplate_$ctor_Z207A3CFB(new Property_CssProperty(140));

export const GridTemplateColumns = GridClasses_GridTemplate_$ctor_Z207A3CFB(new Property_CssProperty(139));

export const GridAutoColumns = GridClasses_GridAuto_$ctor_Z207A3CFB(new Property_CssProperty(126));

export const GridAutoRows = GridClasses_GridAuto_$ctor_Z207A3CFB(new Property_CssProperty(128));

export const GridAutoFlow = GridClasses_GridAutoFlow_$ctor_Z207A3CFB(new Property_CssProperty(127));

export const GridTemplateAreas = GridClasses_GridTemplateAreas_$ctor_Z207A3CFB(new Property_CssProperty(138));

